
import debounce from 'lodash/debounce';
import { mmMatches } from '../utils/utils.matchmedia';
import Siema from 'siema';

Siema.prototype.preventLinkClick = function (selector) {
    const CONTAINER = this.selector.parentNode;
    const LINKS = [...CONTAINER.querySelectorAll(selector)];

    LINKS.forEach(el => {
        let firstMouseX = 0;

        el.addEventListener('mousedown', (e) => firstMouseX = e.clientX);

        el.addEventListener('click', (e) => {
            let lastMouseX = e.clientX;
            let diffMouseX = firstMouseX - lastMouseX;

            if(diffMouseX > 1 || diffMouseX < -1) {
                e.preventDefault();
            }
        });
    });
}

function equalHeightsCarousel(equalHeightItems) {

	if ( !equalHeightItems.length ) {
		return false;
	}

	equalHeightItems.forEach( item => {
		item.setAttribute('style', '');
	});

	const tallestItem = equalHeightItems
							.map( item => item.clientHeight  )
							.reduce( (prev, current) => {
								return (prev > current) ? prev : current;
							}, 0);

	equalHeightItems.forEach( item => {
		item.setAttribute('style', `min-height: ${tallestItem}px`);
	});
}

function disableButton(button) {
	if(button) {
		button.classList.add('is-disabled');
	}
}

function enableButton(button) {
	if(button) {
		button.classList.remove('is-disabled');
	}
}

const	collectionSelectors = document.querySelectorAll('.js-collection-carousel');

[...collectionSelectors].forEach( collectionSelector => {

	let 	carouselList, carouselControls, siemaPrev, siemaNext, mobileItems, tabletItems, desktopItems, equalHeightItems;

	if ( collectionSelector ) {
		
		carouselList = collectionSelector.querySelector('.js-carousel-list');
		carouselControls = collectionSelector.querySelector('.js-collection-carousel-controls');
		equalHeightItems = [...collectionSelector.querySelectorAll('.js-carousel-equal-height-item')];

		// Default currently only uses up to 768px, then up to 1024px, then above 1024px.
		mobileItems 	= collectionSelector.dataset.itemsAtMobile ? collectionSelector.dataset.itemsAtMobile : 1.4;
		tabletItems		= collectionSelector.dataset.itemsAtTablet ? collectionSelector.dataset.itemsAtTablet : 2; 
		desktopItems 	= collectionSelector.dataset.itemsAtDesktop ? collectionSelector.dataset.itemsAtDesktop : 4; 

	}
			
	if ( collectionSelector && carouselControls && carouselList && carouselList.childElementCount > desktopItems ) {

		let currentPage = 1,
			currentItemsPerPage = Math.floor( get_items_per_page() ),
			pageCount = carouselList.childElementCount / currentItemsPerPage;

		collectionSelector.classList.add('is-carousel');
		carouselList.classList.add('is-carousel');
		carouselControls.classList.add('visible');

		const 	siemaPrev = collectionSelector.querySelector('.js-siema-prev'),
				siemaNext = collectionSelector.querySelector('.js-siema-next'),
				mySiema = new Siema({
					selector: 	carouselList,
					easing: 	'ease',
					perPage: 	{
						0: 		mobileItems,
						768: 	tabletItems, 
						1024: 	desktopItems, 
					},
					startIndex: 0,
					draggable: 	true,
		            onInit() {
		            	disableButton(siemaPrev);

		                this.preventLinkClick('li');

		                if ( equalHeightItems.length ) {
							equalHeightsCarousel(equalHeightItems);
		                }
		            },
			        onChange: () => {
			            const numberOfSlides = mySiema.innerElements.length;

			            if(mySiema.currentSlide > 0) {
							enableButton(siemaPrev);
						} else {
							disableButton(siemaPrev);
						}

						if(mySiema.currentSlide + parseFloat( get_items_per_page() ) == numberOfSlides) {
							disableButton(siemaNext);
						} else {
							enableButton(siemaNext);
						}
			        }
				});

		window.addEventListener('resize', debounce( () => {
			reset_vars();
			
			if ( equalHeightItems.length ) {
				equalHeightsCarousel(equalHeightItems);
            }
		}, 200));

		siemaPrev.addEventListener('click', function() {

			mySiema.prev( currentItemsPerPage );

			currentPage -= ( currentPage - 1 ) < 1 ? 0 : 1;

		});

		siemaNext.addEventListener('click', function() {
			
			mySiema.next( currentItemsPerPage );

			currentPage += ( currentPage + 1 ) > pageCount ? 0 : 1;

		});

		function reset_vars () {

			mySiema.goTo(0);

			currentPage = 1;
			currentItemsPerPage = Math.floor( get_items_per_page() );
			pageCount = carouselList.childElementCount / currentItemsPerPage;

		}

		function get_items_per_page () {

			if ( mmMatches('tablet-max') ) {

				return mobileItems;

			} else if ( mmMatches('desktop-max') ) {

				return tabletItems;

			} else {

				return desktopItems;

			}

		}

	}
})
